import "./App.css";
import React, { Suspense, useEffect } from "react";
import Routing from "./Routing/Routing";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import LoaderProvider from "./components/Loader/LoaderProvider";
import { ToastContainer } from "react-toastify";
import { getUserData } from "./utils/utils";
import { saveUserData } from "./redux/Slices/auth";
import { NavbarProvider } from "./components/NavBarContext/NavBarContext";
const { dispatch } = store;
function App() {
  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const data = getUserData();
    if (data) {
      dispatch(saveUserData(data));
    }
  };
  return (
    <Provider store={store}>
      <NavbarProvider>
        <LoaderProvider>
            <Routing />
        </LoaderProvider>
        <ToastContainer />
      </NavbarProvider>
    </Provider>
  );
}

export default App;
